export default ({
  data: {
    result: { id },
  },
}) => {
  return { addressID: id };
};
